import styled from "styled-components";
// -------------------------- 通用模板 --------------------------
export const IconModule = styled.div`
	margin-left: 0 !important;
	margin-top: 6px;
	text-align: center;
	position: relative;
	margin-right: 30px;
`;

export const IconArea = styled.div`
	position: relative;
	cursor: pointer;
`;

export const Icon = styled.img`
	width: 22px;
	height: 22px;
`;

export const ActiveIcon = styled(Icon)`
	opacity: 0;
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0%);
`;

// -------------------------- Search --------------------------
export const SearchContainer = styled.div`
	position: relative;
	display: flex;
	width: 660px;
	box-sizing: border-box;
	margin: 7px 6px 10px 50px;
`;

export const SearchInput = styled.input.attrs({
	placeholderTextColor: "#999999",
})`
	width: 463px;
	border: 2px solid var(--themeColor);
	border-radius: 4px 0 0 4px;
	font-size: 14px;
	font-weight: normal;
	line-height: 12px;
	padding-left: 30px;
	flex-grow: 1;
	height: 36px;
	box-sizing: border-box;

	&:focus {
		outline: none;
		border: 2px solid var(--themeColor);
	}

	&.ani {
		animation: flash 1s;
	}

	@keyframes flash {
		0% {
			background: #ffffff;
		}

		25% {
			background: #ffbbbb;
		}

		50% {
			background: #ffffff;
		}

		75% {
			background: #ffbbbb;
		}

		100% {
			background: #ffffff;
		}
	}
`;

export const SearchIcon = styled.img`
	position: absolute;
	top: 9px;
	left: 8px;
	width: 17px;
	height: 17px;
`;

export const SearchButton = styled.button`
	color: #fff;
	border-radius: 0 4px 4px 0;
	font-size: 16px;
	background: #cb2027;
	border: 0;
	text-shadow: 0 -1px rgba(0, 0, 0, 0.11);
	box-shadow: none;
	height: 36px;
	padding: 0 20px;
	cursor: pointer;

	&:focus {
		outline: none;
		border: 2px solid var(--themeColor);
	}

	&:hover {
		opacity: 0.8;
	}
`;

export const SearchResult = styled.div`
	display: none;
	z-index: 8900;
	position: absolute;
	width: 570px;
	top: 36px;
	box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
	border-radius: 4px;
	border: 1px solid rgba(209, 209, 209, 0.3) !important;
	color: #333;
	background-color: #fff;

	&.isShow {
		display: block;
	}
`;

export const SearchResultList = styled.ul`
	padding: 6px 0;

	&.showSearches {
		padding: 10px 0;
	}
`;

export const SearchResultItem = styled.li`
	padding: 2px 10px 2px 18px;
	height: 28px;
	font-size: 14px;
	line-height: 28px;
	overflow: hidden;
	cursor: pointer;

	&:hover {
		background-color: #f0f0f0;
	}
`;

export const RecentSearchesHeader = styled.h3`
	font-size: 14px;
	color: #999;
	position: relative;
	padding: 0 30px;
	margin: 0;
	display: -webkit-flex;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-weight: normal;
`;

export const RecentSearchesTitle = styled.span`
	line-height: 1.2em;
`;

export const RecentSearchesClear = styled(RecentSearchesTitle)`
	line-height: 1.2em;
	font-size: 14px;
	color: #1b73b5;
	cursor: pointer;
`;

export const RecentSearchesList = styled.ul`
	list-style: none;
`;

export const RecentSearchesItemClear = styled.span`
	font-size: 14px;
	color: #1b73b5;
	cursor: pointer;
	position: absolute;
	right: 30px;
	display: none;
`;

export const RecentSearchesItem = styled.li`
	padding: 0 30px;
	height: 30px;
	font-size: 14px;
	line-height: 30px;
	overflow: hidden;
	cursor: pointer;
	position: relative;

	&:hover {
		background-color: #f0f0f0;
	}

	&:hover ${RecentSearchesItemClear} {
		display: initial;
	}
`;

// -------------------------- Account --------------------------
export const AccountList = styled.div`
	position: absolute;
	background: #fff;
	padding: 15px 15px 10px;
	left: -112px !important;
	border-radius: 4px;
	box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
	border: 1px solid #e6e6e6;
	text-align: left;
	display: none;
	top: 33px !important;
	z-index: 10;
`;

export const Account = styled(IconModule)`
	&:hover ${Icon} {
		opacity: 0;
	}

	&:hover ${ActiveIcon} {
		opacity: 1;
	}

	&:hover ${AccountList} {
		display: block;
	}
`;
export const UserName = styled.div`
	min-width: 220px;
	color:#333;
	font-weight: bold;
	font-size: 13px;
	line-height: 20px;
	padding-bottom: 5px;
	border-bottom: 1px solid #f1f1f1;
`;

export const NotLoggedIn = styled.div`
	text-align: left;
	outline: 0 !important;
`;

export const WelcomeTitle = styled.p`
	font-size: 14px;
	color: #333;
	margin-bottom: 10px;
	text-align: left;
`;

export const NotLoggedInButtons = styled.div`
	padding-bottom: 10px;
	border-bottom: #f2f2f2 1px solid;
	margin-bottom: 5px;
	display: -webkit-flex;
	display: flex;
`;

export const LoginButton = styled.a`
	width: 105px;
	height: 28px;
	line-height: 28px;
	text-align: center;
	background-color: rgba(252, 52, 116, 0.1);
	color: var(--themeColor);
	display: inline-block;
	font-size: 14px;
	text-decoration: none;
	padding: 0;
	-webkit-border-radius: 2px;
	border-radius: 2px;
	white-space: nowrap;
	cursor: pointer;
`;

export const RegisterButton = styled(LoginButton)`
	margin-right: 10px;
	background-color: var(--themeColor);
	color: #fff;
`;

export const AccountItem = styled.a`
	line-height: 12px;
	display: block;
	white-space: nowrap;
	padding: 10px 0;
	font-size: 14px;
	color: #333;
	text-decoration: none;

	&:hover {
		color: var(--themeColor);
		cursor: pointer;
	}
`;

// -------------------------- Favorites --------------------------
export const Favorites = styled(IconModule)`
	margin-left: 5px !important;

	&:hover ${Icon} {
		opacity: 0;
	}

	&:hover ${ActiveIcon} {
		opacity: 1;
	}
`;

// -------------------------- Cart --------------------------
export const CartList = styled.div`
	display: none;
	width: 390px;
	text-align: center;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	font-weight: normal;
	white-space: nowrap;
	right: -26px !important;
	left: auto;
	border-radius: 4px;
	border: 1px solid #e6e6e6;
	font-size: 14px;
	top: 33px !important;
	position: absolute;
	background: #ffffff;
	cursor: default;
	z-index: 10;

	&.isEmpty {
		padding: 40px 0;
	}
`;

export const Cart = styled(IconModule)`
	margin-left: 0 !important;
	margin-right: 0 !important;

	&:hover ${Icon} {
		opacity: 0;
	}

	&:hover ${ActiveIcon} {
		opacity: 1;
	}

	&:hover ${CartList} {
		display: block;
	}
`;
export const CartCount = styled.p`
	position: absolute;
	border-radius: 7px;
	background: var(--themeColor);
	color: #fff;
	right: auto;
	left: 50%;
	top: -8px;
	height: 16px;
	text-align: center;
	line-height: 16px;
	padding: 0 5px;
	z-index: 10;
`;

export const CartEmpty = styled.p`
	width: 86px;
	height: 90px;
	display: block;
	background: url(https://lijc.rightinthebox.com/resource_adcaa602e8222c6eb174f131194292483570c469_ador//dev_v2/base-images/header_empty_cart/cart_empty_ador.png)
		no-repeat 50% 50%;
	background-size: 100% 100%;
	margin: 0 auto 20px;
	color: #666;
`;

export const CartMoreItems = styled.div`
	padding: 0 0 0 15px;
	font-size: 14px;
	border-bottom: #f2f2f2 1px solid;
	color: #999;
	height: 40px;
	line-height: 40px;
	margin-bottom: 5px;
	display: block;
	font-weight: normal;
	text-align: left;
`;

export const CartProductList = styled.div`
	padding: 0 15px;
`;

export const CartProduct = styled.dl`
	text-align: left;
	font-size: 12px;
	margin: 0;

	&.split {
		border-top: 1px solid #f2f2f2;
	}
`;

export const CartProductImgArea = styled.dt`
	width: 60px;
	height: 60px;
	padding-top: 8px;
	position: relative;
	float: left;
	cursor: pointer;
`;

export const CartProductImgLink = styled.a`
	display: inline-block;
	height: 28px;
	text-align: center;
`;

export const CartProductImg = styled.img`
	width: 60px;
	height: 60px;
`;

export const CartProductInfoArea = styled.dd`
	margin-left: 80px;
	padding: 5px 0 24px 0;
	top: 56px !important;
	cursor: pointer;
`;

export const CartProductInfoTitle = styled.h4`
	display: -webkit-box;
	word-break: break-all;
	word-wrap: break-word;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 0;
	margin: 8px 0 5px;
	font-weight: normal;
	font-size: 12px;
	line-height: 15px;
`;

export const CartProductInfoLink = styled.a`
	color: #333333;
	font-size: 14px;
	text-decoration: none;
	white-space: normal;
`;

export const CartProductInfoAttrPrice = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: baseline;
`;

export const CartProductInfoAttr = styled.p`
	color: #333;
	font-size: 12px;
	line-height: 14px;
	flex: 1;
	word-break: break-all;
	white-space: pre-wrap;
`;

export const CartProductInfoColor = styled.span`
	color: #999999;
	font-style: normal;

	&.split {
		margin-left: 15px;
	}
`;

export const CartProductInfoPrice = styled.span`
	color: #222;
	font-weight: 800;
	min-width: 90px;
	text-align: right;
	font-size: 14px;
`;

export const CartProductTotal = styled.p`
	text-align: right;
	border-top: 1px solid #f2f2f2;
	padding: 10px 15px;
	font-size: 14px;
	font-weight: bold;
`;

export const CartProductPrice = styled.strong`
	color: var(--themeColor);
`;

export const CartProductBottom = styled.div`
	border-radius: 0 0 4px 4px;
	padding: 15px 11px 15px 15px;
	background: -webkit-linear-gradient(top, #f2f2f2, #fff);
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const MyCart = styled.a`
	font-size: 14px;
	line-height: 16px;
	width: 130px;
	color: #333;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		color: var(--themeColor);
	}
`;

export const Checkout = styled.a`
	height: 34px;
	line-height: 34px;
	width: 235px;
	border-radius: 2px;
	text-shadow: none;
	font-weight: normal;
	margin: 0;
	display: block;
	font-size: 16px;
	padding: 0 15px;
	background-color: var(--themeColor);
	border-color: var(--themeColor);
	color: #fff;
	cursor: pointer;

	&:hover {
		opacity: 0.8;
	}
`;

export const CheckoutArrow = styled.img`
	vertical-align: top;
	width: 14px;
`;

export const HeaderLogo = styled.a`
	float: left;
	margin-top: -6px;
	padding-top: 3px;
	cursor: pointer;
	text-decoration: none;
`;

export const HeaderButtons = styled.div`
	position: relative;
	display: flex;
	display: -webkit-flex;
`;

export const HeaderPageLet = styled.div`
	height: 88px;
	margin-top: 25px;
	line-height: 18px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const HeaderRightArea = styled.div`
	float: right;
	font-size: 12px;
`;
